import React from 'react';

import { LoginMessagePanel } from '../../../templates/login-message-panel/login-message-panel';

export interface RecoverErrorProps {
  backAction: () => void;
  actionLink: () => void;
}
const ERROR_MESSAGE =
  'Oops! Seems like there was an error recovering your login info. \n Please, try again.';
export function RecoverError({ backAction, actionLink }: RecoverErrorProps) {
  return (
    <LoginMessagePanel
      textLink="Try Again"
      actionLink={actionLink}
      title="Recover your login info"
      type="warning"
      message={ERROR_MESSAGE}
      backAction={backAction}
    />
  );
}
